<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/harvest";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Harvests",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('harvests.singular')) }},
    resourceRoute: {default: 'harvests'},
    modelVariable: {default: 'harvest'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('harvests.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('harvests.plural')),
          href: "/harvests",
        },
        {
          text: this.model && this.model.id ? this.model['id'] : this.$route.params.key,
          href: `/harvests/${this.$route.params.key}`,
          active: false,
        },
        {
          text: this.$t('Edit'),
          href: `/harvests/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName() {
      return this.model['order_id'];
    },
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/harvests/${this.$route.params.key}`, {
        params: {
          // with: 'delivery_items'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/harvests/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/harvests/${this.$route.params.key}`)
    }
  }
}
</script>
